import { useNavigate } from 'react-router-dom';
import { FileUp, PenLine, X } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ProfileEnrichmentCardProps {
  onDismiss: () => void;
  onDismissPermanently: () => void;
}

export const ProfileEnrichmentCard = ({
  onDismiss,
  onDismissPermanently,
}: ProfileEnrichmentCardProps) => {
  const navigate = useNavigate();

  return (
    <Card className="border-primary/30 bg-gradient-to-br from-primary/5 to-transparent relative">
      <button
        onClick={onDismiss}
        className="absolute top-2 right-2 min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0 p-1 rounded-md hover:bg-muted text-muted-foreground hover:text-foreground transition-colors flex items-center justify-center"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <CardContent className="pt-6">
        <h3 className="text-base font-semibold mb-1">
          Help your coach get to know you better
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Import your resume or add career history to get more personalized coaching insights.
        </p>
        <div className="flex flex-wrap gap-2">
          <Button
            size="sm"
            onClick={() => navigate('/settings', { state: { openResumeUpload: true } })}
            className="gap-1.5"
          >
            <FileUp className="w-4 h-4" />
            Import Resume
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/settings')}
            className="gap-1.5"
          >
            <PenLine className="w-4 h-4" />
            Add Manually
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismissPermanently}
            className="text-muted-foreground"
          >
            Don't show again
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
